import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {OutroLightSystem} from "./OutroLightSystem";

export class BonusOutro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine | null;
    private _totalWinText: PIXI.Text;
    private _spinsPlayedText: PIXI.Text;
    private _spinsPlayedNr: PIXI.Text;
    private _countUp: BasicBitmapCountUp;
    private _hoarderLevelText: PIXI.Text;
    private _levelProgression: OutroLightSystem;
    private wrapper: PIXI.Container;
    private _FSname: string;
    private skipped: boolean = false;

    constructor() {
        super();
        this.name = "FSOutroView";
        this.init();
    }


    public hideBonusOutro(): gsap.core.Timeline {
        const hideFSOutroTL: gsap.core.Timeline = gsap.timeline();
        const outroAnimTime: number = SpineGSAPWrapper.animationTimeDuration(this._spine!, `${this._FSname} Outro OUT`);
        hideFSOutroTL.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine!, 0, `${this._FSname} Outro OUT`,false));
        hideFSOutroTL.to([this._spinsPlayedNr, this._totalWinText, this._spinsPlayedText, this._hoarderLevelText, this._levelProgression, this._countUp], {
            alpha: 0,
            duration: outroAnimTime - 0.2
        }, "<");
        hideFSOutroTL.add(XwaysHoarder2.darkOverlay.hideOverlay(outroAnimTime),"<");
        hideFSOutroTL.add(() => {
            this.visible = false;
            this.toggleVisibility(this, false);
            this._levelProgression.endSystem();
            this._spine!.visible = false;
            this._spine!.destroy();
            this._spine = null;
        });

        return hideFSOutroTL;
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }

    }

    public setSkipped(bool: boolean = true): void {
        //debugger;
        this.skipped = bool;
        this._levelProgression.skipped = true;
    }

    public showBonusOutro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalWin: number = XwaysHoarder2.model.gameData.accumulatedRoundWin,
            isZeroWin: boolean = (totalWin === 0),
            startPoint: number = 0,
            isWinBelowStake: boolean = XwaysHoarder2.isWinBelowStake(),
            playedBet: number = XwaysHoarder2.getBuyFeaturePrice(),
            isFsBad: boolean = totalWin < playedBet;
        this.addOutroSpine();
        this.skipped = false;
        this._levelProgression.skipped = false;

      //  tl.to(this, {duration: 0.05}, 0);
        tl.add(() => {
            this._spinsPlayedNr.text = `${XwaysHoarder2.model.gameData.freespinsPlayed}`;
            this.visible = true;
            this.alpha = 1;
            this.toggleVisibility(this, true);
            this._levelProgression.alpha = 1;
            this._totalWinText.visible = !isWinBelowStake;
            //isFsBad ? XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_END_BAD) : XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_END_GOOD);
            //XwaysHoarder2Sound.switchMusic({name: XwaysHoarder2Sound.BONUS_OUTRO});
            this.onResize();
        }, ">");
        tl.add(this._levelProgression.startSytem());
       // tl.to(this._spine, {duration: 0.05, alpha: 1});
        tl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_SIGN_SCALE_IN);
        }, "<");
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine!, 0, `${this._FSname} Outro IN`,false));
        tl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_SIGN_FALL_DOWN);
        }, "<0.1");
        tl.add(() => {
            //debugger;
            if(!this.skipped) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_SHOTS);
            }
        }, "<0.5");


        if (!isWinBelowStake && !isZeroWin) {
            tl.to(this._totalWinText, {
                duration: 1,
                alpha: 1
            });
        }

        const betLevel = XwaysHoarder2.apiPlugin.freeBets.hasFreeBets() ? XwaysHoarder2.apiPlugin.freeBets.getBet() : XwaysHoarder2.apiPlugin.betLevel.getLevel(),
            price: number = XwaysHoarder2.model.gameData?.playedBetValue || parseFloat(betLevel);


        const hasCountUp: boolean = !(isWinBelowStake);
        this._countUp.stopAt(0);
        this._countUp.scale.set(0.5, 0.5);
        this._countUp.alpha = 0;
        this._countUp.visible = true;


        tl.to(this._countUp, {duration: 0.2, alpha: 1});
        tl.to(this._countUp.scale, {duration: 0.1, x: 1, y: 1, ease: "sine.in"}, "<");
        tl.add(this._countUp.getCountAnimation(0, totalWin, hasCountUp ? 1.5 : 0.001), ">");
        if (hasCountUp && !isZeroWin) {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.COUNTUP);
            }, "<");
        }

        tl.to([this._spinsPlayedNr, this._spinsPlayedText], {duration: 0.5, alpha: 1});
        if(hasCountUp && !isZeroWin) {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.COUNTUP_END_LARGE);
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.COUNTUP);
            }, "<");
        }

        return tl;
    }

    private init(): void {


        this._totalWinText = new PIXI.Text("", new PIXI.TextStyle(XwaysHoarder2Statics.TRANSITION_HEADING_STYLE));
        this._totalWinText.visible = false;
        this._totalWinText.text = XwaysHoarder2.apiPlugin.translations.translate("TOTAL WIN");
        this._totalWinText.name = "total win Text";
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(353, 270);
        if (this._totalWinText.width > 210) {
            this._totalWinText.scale.set(210 / this._totalWinText.width, 210 / this._totalWinText.width);
        }
        this._totalWinText.alpha = 0;
        this.addChild(this._totalWinText);

        this._hoarderLevelText = new PIXI.Text("RADIATION LEVEL", new PIXI.TextStyle(XwaysHoarder2Statics.OUTRO_TRANSITION_CONTENT_STYLE));
        this._hoarderLevelText.name = "Radiation level text";
        this._hoarderLevelText.visible = false;
        this._hoarderLevelText.anchor.set(0.5);
        this._hoarderLevelText.style.fontSize = 36;
        this._hoarderLevelText.position.set(360, 350);
        this._hoarderLevelText.alpha = 0;
        this.addChild(this._hoarderLevelText); //#TODI ask and remve this properly

        this._levelProgression = new OutroLightSystem();
        this.addChild(this._levelProgression);

        this.wrapper = new PIXI.Container();
        this.wrapper.name = "SpinsPlayedWrapper";

        this._spinsPlayedText = new PIXI.Text("", new PIXI.TextStyle(XwaysHoarder2Statics.OUTRO_TRANSITION_CONTENT_STYLE2));
        this._spinsPlayedText.text = XwaysHoarder2.apiPlugin.translations.translate("SPINS PLAYED");
        this._spinsPlayedText.visible = false;
        this._spinsPlayedText.name = "spins Played Text";
        this._spinsPlayedText.alpha = 0;
        this.wrapper.addChild(this._spinsPlayedText);


        this._spinsPlayedNr = new PIXI.Text("", new PIXI.TextStyle(XwaysHoarder2Statics.OUTRO_TRANSITION_CONTENT_STYLE3));
        this._spinsPlayedNr.name = "spins played no";
        this._spinsPlayedNr.visible = false;
        this._spinsPlayedNr.alpha = 0;
        this._spinsPlayedNr.x = this._spinsPlayedText.width + 5;
        this.wrapper.addChild(this._spinsPlayedNr);
        this.wrapper.position.set(360 - ((this._spinsPlayedNr.width + this._spinsPlayedText.width)/2), 520);

        this.addChild(this.wrapper);


        this._countUp = new BasicBitmapCountUp({
            fontName: XwaysHoarder2GameAssets.WIN_COUNT_UP,
            fontSize: 25,
            tint: 0xffffff
        }, 230, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 347);
        this._countUp.name = "countup amount";
        this._countUp.stopAt(0);
        this.visible = false;
        this.addChild(this._countUp);

        this.onResize();
    }


    private toggleVisibility(parentContainer: PIXI.Container | PIXI.Sprite, toShow: boolean): void {
        parentContainer.children.forEach((item) => {
            item.visible = toShow;
        });
        this._spinsPlayedText.visible = toShow;
        this._spinsPlayedNr.visible = toShow;
    }


    private addOutroSpine(): void {
        let spineName: string = XwaysHoarder2.model.data.mode === GameMode.FREESPIN ? XwaysHoarder2GameAssets.FS_INTRO_OUTRO : XwaysHoarder2GameAssets.SFS_INTRO_OUTRO
        if (XwaysHoarder2.model.data.currentFSLevel >= 4) {
            spineName = XwaysHoarder2GameAssets.BINGE_INTRO_OUTRO;
        }
        this._spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(spineName));
        this._spine.position.set(360, 290);
        this._spine.name = "outroSpine";
      //  this._spine.alpha = 0;
        this._FSname = XwaysHoarder2.model.data.mode === GameMode.FREESPIN ? "FS" : "SFS";
        if (XwaysHoarder2.model.data.currentFSLevel >= 4) {
            this._FSname = "Binge";
        }
        this.addChild(this._spine, this._totalWinText, this._hoarderLevelText, this._levelProgression, this.wrapper, this._countUp);
    }


}